import React from "react";
import ContractsByHierarchyContext from "./components/Reports/Contract/byHierarchy/ContractsByHierarchyContext";
import HeaderWithHelpDialog from "./components/Reports/Contract/directBelow/HeaderWithHelpDialog";
import { CONTRACT_SITUATIONS, CUSTOMER_ROUTES, HierarchyViewTypeEnum } from "../util";

import PageContainer from "../custom/Page";

const params = { hierarchyViewType: HierarchyViewTypeEnum.DIRECTLY };

const ReportContractDirectBelow = () => (
  <PageContainer full>
    <HeaderWithHelpDialog />
    <ContractsByHierarchyContext
      params={params}
      hierarchyViewType={HierarchyViewTypeEnum.DIRECTLY}
      contractSituations={[CONTRACT_SITUATIONS.EXECUTING]}
      customerRoutePrefix={CUSTOMER_ROUTES.AGENT}
    />
  </PageContainer>
);

export default ReportContractDirectBelow;
